import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CartListType1 from '../../components/CartListType1';
import { useSelector } from 'react-redux';
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme)=>({
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },
}));

const Cart = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();
  const login = useSelector(state => state.user.login);
  const mbId = useSelector(state => state.user.userInfo['mb_id']);
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if(!login){
      navigate("/Login");
    }

  }, [login])


  const getCartItems = async() => {
    if (!mbId) return;
    try {
      setLoading(true)
      const res = await axios.post('/api/shop/getCart/', {mb_id: mbId})
      if(res.data.success === false) {
        alert('불러오기 실패')
        setLoading(false)
        return
      }
      setData(res.data.result)
      setLoading(false)
  
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getCartItems()
  } , [mbId])

  useEffect(() => {

    return () => {
      setData([])
    }
  }, [])

  return (
    <div>
      {loading ? (
          <div className={classes.load}>
            <TbLoader className={classes.loadingIcon}/>
          </div>
        ) : (
          <CartListType1 
            data={data} 
            setData={setData}
            getCartItems={getCartItems} 
          />
        )}

    </div>
  )
}



export default Cart
